import { useQuery } from '@tanstack/react-query';
import InteractionService from '@/services/InteractionService';
import { cptWindow, currentMonthCptSeconds, groupEntriesByMonth } from '@/logic/timeTracking';
import { INTERACTION_KEYS } from './keys';

// Time data must read fresh (the chip seed + tab history change every flush) —
// short staleTime; freshness otherwise comes from mount refetch + mutation
// invalidation (the global client disables refetchOnWindowFocus).
const TIME_STALE_MS = 30_000;

/**
 * Persisted current-month time-CPT seconds — the timer chip's seed.
 * refetchInterval re-syncs the seed after the store's 5-min auto
 * flushes (which bypass TanStack), so the chip's total self-corrects instead
 * of dropping 5 min until the next mount.
 */
export function useCurrentMonthCptSeconds(userid: string | number | null | undefined) {
  return useQuery({
    queryKey: INTERACTION_KEYS.cpt(userid ?? ''),
    queryFn: () => InteractionService.listCptInteractions(userid!, cptWindow()),
    enabled: userid != null && userid !== '',
    staleTime: TIME_STALE_MS,
    refetchInterval: 60_000,
    select: currentMonthCptSeconds,
  });
}

/** Month-grouped entry history (newest first) — the Time tab's projection. */
export function useTimeEntriesByMonth(userid: string | number | null | undefined) {
  return useQuery({
    queryKey: INTERACTION_KEYS.times(userid ?? ''),
    queryFn: () => InteractionService.listTimeEntries(userid!),
    enabled: userid != null && userid !== '',
    staleTime: TIME_STALE_MS,
    select: groupEntriesByMonth,
  });
}
